import { fetch } from 'whatwg-fetch'
(function () {
  var shortid = require('shortid')
  var Raven = require('raven-js')
  var Store = require('./Store').default
  var Leadhit = require('./Leadhit').default

  const ravenUrl = 'https://f704e55638d14ab284f08be5d83efb3d@sentry.dev.leadhit.ru/4'
  Raven.config(ravenUrl, {
    release: TrackVersion,
    whitelistUrls: [/^(|https?:\/\/)track\.leadhit\.(io|ru).*/],
    captureUnhandledRejections: false
  }).install()

  function setExistCounterOrOrderScript (codeType) {
    var url = Store.state.proto + Store.state.trackUrlV2 + 'set/site/code_checked'
    var data = JSON.stringify({
      site_id: window.lh_clid,
      code_type: codeType
    })

    fetch(url, { method: 'POST', body: data })
  }
  function checkExistCounterAndOrder () {
    if (Store.state.siteSettings.hasOwnProperty('counter_checked') && Store.state.siteSettings.counter_checked === false) {
      setExistCounterOrOrderScript('counter')
    }
    if (Store.state.siteSettings.hasOwnProperty('order_code_checked') && Store.state.siteSettings.order_code_checked === false) {
      var orderScriptTimer = setInterval(function () {
        var scriptElem = document.querySelector('script.lh-order-script')
        if (scriptElem) {
          clearInterval(orderScriptTimer)
          orderScriptTimer = null
          setExistCounterOrOrderScript('order')
        }
      }, 1000)
      setTimeout(function () {
        clearInterval(orderScriptTimer)
        orderScriptTimer = null
      }, 10000)
    }
  }

  function getFormsData () {
    var url = Store.state.proto + Store.state.trackUrlV2 + 'get/site/forms?site_id=' + window.lh_clid
    fetch(url).then(function (response) {
      response.text().then(function (response) {
        try {
          response = JSON.parse(response)
          var editedForms = response.map(function (form) {
            var fields = JSON.parse(JSON.stringify(form.fields))
            form.fields = []
            Array.from(Object.keys(fields)).forEach(function (key) {
              var field = {
                name: {
                  key: fields[key],
                  value: key
                },
                alias: {
                  key: fields[key],
                  value: form.fields_aliases[fields[key]] || ''
                },
                selector: {
                  key: fields[key],
                  value: form.fields_selector[fields[key]] || ''
                }
              }
              form.fields.push(field)
            })
            delete form.fields_aliases
            delete form.fields_selector

            if (!form.by_click.hasOwnProperty('active')) {
              form.by_click.active = false
              form.by_click.selector = ''
            }

            return form
          })

          Store.state.existingForms = editedForms

          window.Leadhit.showFormCollector()
        } catch (e) {
          console.log('getFormsData, Error: ', e)
        }
      }).catch(function (e) {
        console.log('getFormsData, Error: ', e)
      })
    }).catch(function (e) {
      console.log('getFormsData, Error: ', e)
    })
  }
  function requestCheckNeedShowFormCollector (token) {
    var url = Store.state.proto + Store.state.trackUrlV2 + 'check/site/forms_token?site_id=' + window.lh_clid + '&token=' + token
    fetch(url).then(function (response) {
      response.text().then(function (response) {
        try {
          response = JSON.parse(response)
          if (response.token_is_valid) {
            localStorage.setItem('lh-show-form-collector', token)
            getFormsData()
          }
        } catch (e) {
          console.log('requestCheckNeedShowFormCollector, Error: ', e)
        }
      }).catch(function (e) {
        console.log('requestCheckNeedShowFormCollector, Error: ', e)
      })
    }).catch(function (e) {
      console.log('requestCheckNeedShowFormCollector, Error: ', e)
    })
  }
  function checkNeedShowFormCollector () {
    var attrMatch = window.location.href.match(/lh_forms_editor_token=.{1,15}/g)
    if (attrMatch && attrMatch.length > 0) {
      var token = attrMatch[0].split('=')[1]
      requestCheckNeedShowFormCollector(token)
    } else if (localStorage.getItem('lh-show-form-collector')) {
      requestCheckNeedShowFormCollector(localStorage.getItem('lh-show-form-collector'))
    }
  }

  function getSiteSettings (callback) {
    var url = Store.state.proto + Store.state.trackUrlV2 + 'get/site/settings?site_id=' + window.lh_clid
    fetch(url).then(function (response) {
      response.text().then(function (response) {
        try {
          response = JSON.parse(response)
          if (!response.lh_vars.hasOwnProperty('forms_script')) {
            response.lh_vars.forms_script = ''
          }

          Store.state.siteSettings = response
          callback()

          checkExistCounterAndOrder()
        } catch (e) {
          callback()
          console.log('getSiteSettings, Error: ', e)
        }
      }).catch(function (e) {
        callback()
        console.log('getSiteSettings, Error: ', e)
      })
    }).catch(function (e) {
      callback()
      console.log('getSiteSettings, Error: ', e)
    })
  }

  function checkAllowedBrowsers () {
    /* eslint-disable */
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1) {
      // We don't work in IE for now
      return false;
    } else {
      return true;
    }
    /* eslint-enable */
  }

  function checkAllowedDomains () {
    var url = Store.state.proto + Store.state.trackUrlV2 + 'check/site/allowed-domains?site_id=' + window.lh_clid
    fetch(url).then(function (response) {
      response.text().then(function (response) {
        try {
          response = JSON.parse(response)
          if (response.status === 'success' && response.domains) {
            if (response.domains.length === 0 || response.domains.includes(window.location.hostname)) {
              checkAllowedGDPR()
            }
          }
        } catch (e) {
          checkAllowedGDPR()
          console.log('Check allowed domains, Error: ', e)
        }
      }).catch(function (e) {
        checkAllowedGDPR()
        console.log('Check allowed domains, Error: ', e)
      })
    }).catch(function (e) {
      checkAllowedGDPR()
      console.log('Check allowed domains, Error: ', e)
    })
  }

  function startTracker (LeadhitInst) {
    const agent = window.navigator.userAgent

    if (agent.toLowerCase().indexOf('googlebot') !== -1 ||
        agent.toLowerCase().indexOf('yandex.com/bots') !== -1 ||
        agent.toLowerCase().indexOf('mail.ru_bot') !== -1 ||
        agent.toLowerCase().indexOf('msnbot') !== -1 ||
        agent.toLowerCase().indexOf('bingbot') !== -1 ||
        agent.toLowerCase().indexOf('stackrambler') !== -1 ||
        agent.toLowerCase().indexOf('yahoo! slurp') !== -1 ||
        agent.toLowerCase().indexOf('slurp') !== -1 ||
        agent.toLowerCase().indexOf('duckduckbot') !== -1
    ) {
      return
    }

    try {
      LeadhitInst.init()
      LeadhitInst.loadSiteVariables()
      LeadhitInst.processVisit()
      LeadhitInst.startCollectorForClosedPagesForms()
    } catch (e) {
      LeadhitInst.debugLog(e)
    }

    setTimeout(function () {
      LeadhitInst.store.state.initialUrl = location.href
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
          if (location.href !== LeadhitInst.store.state.initialUrl) {
            LeadhitInst.store.state.initialUrl = location.href
            try {
              LeadhitInst.init()
              LeadhitInst.loadSiteVariables()
              LeadhitInst.processVisit()
              LeadhitInst.store.state.pageID = shortid.generate()
            } catch (e) {
              LeadhitInst.debugLog(e)
            }
          }
        })
      })
      var observeConfig = { childList: true, attributes: true, characterData: true, subtree: true }
      var timerCheckDocument = setInterval(function () {
        if (document.readyState === 'complete') {
          clearInterval(timerCheckDocument)
          timerCheckDocument = null

          try {
            observer.observe(document.body, observeConfig)
          } catch (error) {
            console.log('observe error', error)
          }
        }
      }, 100)
    }, 0)

    window.Leadhit = LeadhitInst

    checkNeedShowFormCollector()
  }

  function setLeadApprovement (LeadhitInst, leadId, collectApproved) {
    var url = LeadhitInst.store.state.proto + LeadhitInst.store.state.trackUrlV2 + 'set/lead/approvement'
    var data = JSON.stringify({
      lead_id: leadId,
      site_id: window.lh_clid,
      referrer: LeadhitInst.getReferrer(),
      collect_approved: collectApproved
    })

    fetch(url, { method: 'POST', body: data })
      .then(function (response) {
        response.text().then(function (text) {
          try {
            text = JSON.parse(text)

            localStorage.setItem('lh_data_collect_approved', JSON.stringify({
              collect_approved: collectApproved,
              date_start: new Date()
            }))

            if (collectApproved) {
              startTracker(LeadhitInst)
            }
          } catch (e) {
            LeadhitInst.debugLog(e)
          }
        }).catch((e) => {
          LeadhitInst.debugLog(e)
        })
      }).catch((e) => {
        LeadhitInst.debugLog(e)
      })
  }

  function showApprovementWindow (LeadhitInst, leadId) {
    var approveWindow = `
    <div class="lh-approvement-window">
      <div style="text-align: center; margin-bottom: 8px;">
        Confirm consent to the processing of personal data.
      </div>
      <div style="text-align: center;">
        <button class="lh-cancel-approvement-button">
          Decline
        </button>
        <button class="lh-confirm-approvement-button">
          Accept
        </button>
      </div>
    </div>
    `
    var styles = `
    <style>
      .lh-approvement-window {
        border: 1px solid grey;
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 90px;
        padding: 10px 5%;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        background: white;
        z-index: 1000;
      }
      .lh-approvement-window button {
        border-radius: 3px;
        cursor: pointer;
        border: unset;
        height: 35px;
        color: white;
      }
      .lh-cancel-approvement-button {
        margin-right: 15px;
        background: #ee6c4c;
      }
      .lh-cancel-approvement-button:hover {
        background: #c23b22;
      }
      .lh-cancel-approvement-button:active {
        background: #8a1700;
      }
      .lh-confirm-approvement-button {
        background: #668a6a;
      }
      .lh-confirm-approvement-button:hover {
        background: #4f7353;
      }
      .lh-confirm-approvement-button:active {
        background: #1d4f36;
      }
    </style>`

    document.head.insertAdjacentHTML('beforeend', styles)
    document.body.insertAdjacentHTML('beforeend', approveWindow)

    setTimeout(function () {
      var cancelButton = document.querySelector('button.lh-cancel-approvement-button')
      if (cancelButton) {
        cancelButton.addEventListener('click', function () {
          var lhApprovementWindow = document.querySelector('.lh-approvement-window')
          if (lhApprovementWindow) {
            lhApprovementWindow.style.display = 'none'
            setLeadApprovement(LeadhitInst, leadId, false)
          }
        })
      }

      var confirmButton = document.querySelector('button.lh-confirm-approvement-button')
      if (confirmButton) {
        confirmButton.addEventListener('click', function () {
          var lhApprovementWindow = document.querySelector('.lh-approvement-window')
          if (lhApprovementWindow) {
            lhApprovementWindow.style.display = 'none'
            setLeadApprovement(LeadhitInst, leadId, true)
          }
        })
      }
    }, 0)
  }

  function getLeadApprovement (LeadhitInst, leadId) {
    var url = LeadhitInst.store.state.proto + LeadhitInst.store.state.trackUrlV2 + 'check/lead/approvement?' + 'site_id=' + window.lh_clid + '&lead_id=' + leadId
    fetch(url).then(function (response) {
      response.text().then(function (text) {
        try {
          text = JSON.parse(text)

          if (text.detail === 'Lead not found') {
            showApprovementWindow(LeadhitInst, leadId)
          } else if (text.data_collect_approved) {
            startTracker(LeadhitInst)
          }
        } catch (e) {
          LeadhitInst.debugLog(e)
        }
      }).catch((e) => {
        LeadhitInst.debugLog(e)
      })
    }).catch((e) => {
      LeadhitInst.debugLog(e)
    })
  }

  function getLeadId (LeadhitInst) {
    var leadId = LeadhitInst.getUID() || LeadhitInst.getURLParameter('lead_id')
    if (!leadId || leadId === 'None') {
      LeadhitInst.getLeadIdRequest()
        .then(function (response) {
          response.text().then(function (text) {
            try {
              leadId = JSON.parse(text)[window.lh_clid]
              getLeadApprovement(LeadhitInst, leadId)
            } catch (e) {
              LeadhitInst.debugLog(e)
            }
          }).catch((e) => {
            LeadhitInst.debugLog(e)
          })
        }).catch((e) => {
          LeadhitInst.debugLog(e)
        })
    } else {
      getLeadApprovement(LeadhitInst, leadId)
    }
  }

  function getSiteApprovement (LeadhitInst) {
    var url = LeadhitInst.store.state.proto + LeadhitInst.store.state.trackUrlV2 + 'check/site/approvement?' + 'site_id=' + window.lh_clid
    fetch(url).then(function (response) {
      response.text().then(function (text) {
        try {
          text = JSON.parse(text)
          localStorage.setItem('lh_data_collect_need_approvement', text.collect_approvement)
          if (!text.collect_approvement) {
            startTracker(LeadhitInst)
          } else {
            getLeadId(LeadhitInst)
          }
        } catch (e) {
          startTracker(LeadhitInst)
          LeadhitInst.debugLog(e)
        }
      }).catch(function (e) {
        startTracker(LeadhitInst)
        LeadhitInst.debugLog(e)
      })
    }).catch(function (e) {
      startTracker(LeadhitInst)
      LeadhitInst.debugLog(e)
    })
  }

  function checkAllowedGDPR () {
    var localStorageAvailable = true
    try {
      localStorage.setItem('leadhit_tracker', '1')
    } catch (e) {
      localStorageAvailable = false
    }

    if (localStorageAvailable) {
      var LeadhitInst = new Leadhit(Raven, Store)

      var localStorageNeedApprovement = localStorage.getItem('lh_data_collect_need_approvement')

      if (localStorageNeedApprovement === null) {
        getSiteApprovement(LeadhitInst)
      } else if (localStorageNeedApprovement === 'true') {
        var dataCollectApproved = localStorage.getItem('lh_data_collect_approved')
        try {
          dataCollectApproved = JSON.parse(dataCollectApproved)
        } catch (e) {}

        if (dataCollectApproved === null) {
          getLeadId(LeadhitInst)
        } else if (dataCollectApproved.hasOwnProperty('collect_approved')) {
          if (dataCollectApproved.collect_approved === true) {
            startTracker(LeadhitInst)
          }
        }
      } else if (localStorageNeedApprovement === 'false') {
        startTracker(LeadhitInst)
      }
    }
  }

  function checkRunTracker () {
    if (checkAllowedBrowsers()) {
      getSiteSettings(checkAllowedDomains)
    }
  }

  checkRunTracker()
})()
